/*
 * fn: isModifiedClick
 *
 * Determines if a mouse click was modified by another input
 *
 */
import { type MouseEvent } from 'react'

export const isModifiedClick = (e: MouseEvent<HTMLElement>) =>
  e.button === 1 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey
